module.exports = __webpack_public_path__ + "img/tls_certificate.5a7192bd.png";